import { Directive, HostListener, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: 'ng-select[nullToZero]'
})
export class NgSelectNullToZeroDirective implements OnInit, AfterViewInit, OnDestroy {
    private subscription: Subscription = new Subscription();

    constructor(private ngControl: NgControl) { }

    ngOnInit(): void {
        if (this.ngControl?.control) {
            // Subscribe to valueChanges (programmatic or input changes)
            this.subscription = this.ngControl.control.valueChanges.subscribe(value => {
                if (value === null) {
                    this.ngControl.control.setValue(0, { emitEvent: false });
                }
            });
        }
    }

    ngAfterViewInit(): void {
        // Also fix initial null values after view is ready
        setTimeout(() => {
            if (this.ngControl?.control && this.ngControl.control.value === null) {
                this.ngControl.control.setValue(0, { emitEvent: false });
            }
        });
    }

    // Listen to DOM change events
    @HostListener('change', ['$event'])
    onChange(event: any) {
        if (this.ngControl?.control && this.ngControl.control.value === null) {
            this.ngControl.control.setValue(0, { emitEvent: false });
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
